module.exports = __webpack_public_path__ + "img/2-6-6.5c9a742c.png";